// Distribution: Standard (3-question) = buckets 0-5 (50%), Extended (5-question) = buckets 6-11 (50%)
export const onboardingExtendedQuestionnaireBuckets = [6, 7, 8, 9, 10, 11]
